import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=8166f168&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8166f168",
  null
  
)

component.options.__file = "Breadcrumbs.vue"
export default component.exports